import React from 'react';
import styles from './Advt.module.css';
import cn from 'classnames';
import { iconsSourcesSvg } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const Advt = React.memo(({ className, advtInfo }) => {
  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, '-');
  return (
    <div
      className={cn(className, styles.wrapper, {
        [styles.wrapperHidden]:
          !advtInfo.qrCode &&
          !advtInfo.label &&
          !advtInfo.socials &&
          !advtInfo.number,
      })}>
      <div className={styles.container}>
        {advtInfo.qrCode && (
          <div className={styles.left}>
            <img src={advtInfo.qrCode ? advtInfo.qrCode : ''} alt="" />
          </div>
        )}
        <div className={styles.right}>
          <div className={styles.title}>{advtInfo.label}</div>
          <div className={styles.desc}>
            {advtInfo.socials &&
              advtInfo.socials.map((item) => (
                <div key={item} className={styles.icon}>
                  {iconsSourcesSvg[item]}
                </div>
              ))}
            <div className={styles.number}>{phoneNumberFormat}</div>
          </div>
        </div>
        <span className={styles.buble1}></span>
        <span className={styles.buble2}></span>
        <span className={styles.buble3}></span>
        <span className={styles.buble4}></span>
        <span className={styles.buble5}></span>
      </div>
    </div>
  );
});

export default Advt;
